import { render, staticRenderFns } from "./Departments.vue?vue&type=template&id=7745d883&scoped=true"
import script from "./Departments.vue?vue&type=script&lang=js"
export * from "./Departments.vue?vue&type=script&lang=js"
import style0 from "./Departments.vue?vue&type=style&index=0&id=7745d883&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7745d883",
  null
  
)

export default component.exports